import { useEffect } from "react";
import { pick } from "@/lib/languages";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { pageTitlesL as L } from "@/i18n/common";
import { groupTripL } from "@/i18n/groupTrips";

/**
 * Gives each page its own browser title. Every route used to share the one
 * static title from index.html, so the search results, a hotel and a
 * confirmation were indistinguishable in a tab strip, in the history and
 * in a bookmark. The title follows the language too.
 */
const BRAND = "Toukky";

export function titleFor(pathname, l) {
  const path = String(pathname || "/").replace(/\/+$/, "") || "/";
  const first = path.split("/")[1] || "";
  const exact = l.exact[path];
  if (exact) return exact;
  if (first === "hotels") return l.hotelDetail;
  if (first === "flights") return path.endsWith("/passengers") ? l.passengers : l.flightDetail;
  if (first === "cars") return l.carDetail;
  if (first === "booking") return path.endsWith("/success") ? l.bookingSuccess : l.bookingDetail;
  if (first === "partner") return l.partnerArea;
  // "/support/cases" itself is an exact title; one level below it is a case.
  if (/^\/support\/cases\/[^/]+$/.test(path)) return l.supportCase;
  return "";
}

export default function RouteTitle() {
  const { pathname } = useLocation();
  const { lang, siteLang = lang } = useSettings();
  useEffect(() => {
    const l = pick(L, siteLang);
    const groups = pathname === "/groups" || pathname.startsWith("/groups/") ? pick(groupTripL, lang) : null;
    const title = groups ? (/^\/groups\/new\/?$/.test(pathname) ? groups.createTitle : groups.groupsTitle) : titleFor(pathname, l);
    document.title = title ? `${title} · ${BRAND}` : l.home;
  }, [pathname, lang, siteLang]);
  return null;
}
